'use strict';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import PlanEditor from '../../components/Plans/Editor.react';

import styles from './Customizer.scss';

export default class Customizer extends Component {
    static contextTypes = {
        router: PropTypes.object,
        confirm: PropTypes.func,
        isPro: PropTypes.bool,
        isMobile: PropTypes.bool,
        isCordova: PropTypes.bool,
        showLoginForm: PropTypes.func,
    };

    render = () => {
        const { params, location } = this.props;
        const { router, confirm, isPro, isMobile, isCordova, showLoginForm } = this.context;

        return (
            <div className="customizer-page">
                <Link to="/">
                    <img className="eatlove-logo-header" src="https://static.chewba.info/images/header-logo-gray-green-2017-07-03.png" />
                </Link>
                <PlanEditor uuid={params.uuid}
                    location={location}
                    firstRun={location && location.query && location.query.signup ? true : false}
                    showAddToPlanner={true}
                    router={router}
                    confirm={confirm}
                    isPro={isPro}
                    isMobile={isMobile}
                    isCordova={isCordova}
                    showLoginForm={showLoginForm} />
            </div>
        );
    }
}
